import { Div, RefString, Collection, Select } from '@tblabs/truffle';
import { Playlist } from '../Models/Playlist';
import { PlayerLogic } from './PlayerLogic';


export class PlaylistSelector extends Div
{
    constructor(_playerLogic: PlayerLogic)
    {
        super("playlist-selector");

        const currentPlaylistName = new RefString(_playerLogic.CurrentPlaylist.Name);
        // const availablePlaylistsNames = new Collection<string>(_playerLogic.AvailablePlaylists.Map(playlist => playlist.Name));
        const availablePlaylistsNames = new Collection<string>();
        
        _playerLogic.CurrentPlaylist.OnChange((playlist: Playlist) =>
        {
            currentPlaylistName.value = playlist.Name;
        });

        _playerLogic.AvailablePlaylists.OnChange((playlists: Playlist[]) =>
        {
            availablePlaylistsNames.Load(...playlists.map(playlist => playlist.Name));
        }, true);

        currentPlaylistName.OnChange((name: string) =>
        {
            _playerLogic.CurrentPlaylist.object = _playerLogic.AvailablePlaylists.Find(playlist => playlist.Name === name) || Playlist.Default;
        });

        this.Append(
            new Select(currentPlaylistName, availablePlaylistsNames)
                .AddDefaultOption("All songs")
        );
    }
}
